import React, { useContext, useEffect, useState } from 'react';
import AppContext from "../AppContext"
import { Popconfirm, Row, Card, message, Button, Table, Radio, Col, List, Input, Space, Select, Modal, Spin, Divider } from "antd";
import { GetTranslation } from '../../Models/shared/general';
import { Redirect, useNavigate } from "react-router-dom";
import Highlighter from 'react-highlight-words';
import { ArrowRightOutlined, SearchOutlined, UserAddOutlined, HomeTwoTone, ContactsTwoTone, HomeOutlined, ContactsOutlined, DeleteOutlined } from '@ant-design/icons';
import moment, { duration } from 'moment';
import { parse } from 'uuid';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Avatar from 'antd/lib/avatar/avatar';
import randomColor from "randomcolor";

import { onSearchUser, onRequestAddUser, getUserbyId, getAllUserLists, onGetUserContact, onRequestAproveUser, onRequestRemoveUser } from "../../Controller/Management/UserProf_Ctrl"
import { ListConsumer } from 'antd/lib/list';
import Title from 'antd/lib/skeleton/Title';

import '../../css/Contactlist.css'; // Import your CSS file here
import useId from '@mui/material/utils/useId';


export default function ContactList(props) {
    const global = useContext(AppContext);
    const userid = global.UserIdentity.userid;
    const username = global.UserIdentity.username;
    const dispatch = useDispatch();

    const globalgrouping = global.UserIdentity.grouping;

    const [datasourceCONTACT, setDataSourceCONTACT] = useState([]);

    const [listloading1, setlistloading1] = useState(false)
    const [ModaladdContact, setModaladdContact] = useState(false);

    const [approveAction, setApproveAction] = useState("")
    const [removeAction, setRemoveAction] = useState("")
    const [searchAction, setSearchAction] = useState("")
    const [datasourceCONTACTDisplay, setDataSourceCONTACTDisplay] = useState([]);
    const [tempdatasourceCONTACT, setTempDataSourceCONTACT] = useState([]);

    const [searchresult, setsearchresult] = useState("")
    const [searchkeyword, setsearchkeyword] = useState("")
    const userlang = navigator.language || navigator.userLanguage;

    const [isMaintenance, setIsMaintenance] = useState(false);

    const globaldepartment = global.UserIdentity.department;
    const [search, setSearch] = useState({ Text: "", Column: "" })

    const onRefreshContactlistV1 = () => {
        onGetUserContact({ userid: userid })
            .then((val) => {
                if (val.data.length > 0) {
                    // Count the number of objects where cstatus is 0
                    const countCStatusZero = val.data.reduce((count, obj) => {
                        if (obj.cstatus === 0) {
                            count += 1;
                        }
                        return count;
                    }, 0);

                    localStorage.setItem("pendingcontact", countCStatusZero)

                    setDataSourceCONTACT(val.data)
                    setDataSourceCONTACTDisplay(val.data)
                }
                else {
                    localStorage.setItem("pendingcontact", 0)
                }

                return val;
            })
            .catch(err => {
                message.error(GetTranslation(userlang, "Cannot get data"));
            });
    }

    //====== ON GET USER LISTS ======= 
    const onRefreshContactlistV2 = async () => {
        var result = await onGetUserContact({ userid: userid })

        var finaluserlist = []
        var finalmentionuserlist = []

        return getAllUserLists({})
            .then(user => {

                // setFULLUserLists(user.data)
                let usertemplist1 = user.data

                var ownuserid = usertemplist1.filter(x => x._id == userid);

                var tempuserid = usertemplist1.filter(x => x._id != userid);

                let tempmentionuserlist = []

                var usertemplist = []
                usertemplist.push(ownuserid[0])

                for (var x = 0; x < tempuserid.length; x++) {
                    usertemplist.push(tempuserid[x])
                }


                if (globalgrouping == "public") {

                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist

                }
                else if (globalgrouping == "private") {
                    let temptable = usertemplist
                    let temptable1 = usertemplist

                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1._id == userid;
                    });
                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });

                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist
                }
                else if (globalgrouping == "department") {

                    let temptable = usertemplist
                    let temptable1 = usertemplist
                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1.department == globaldepartment;
                    });

                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });

                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist

                }
                else {
                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist
                }


                var result1
                if (result.data.length != undefined) {
                    result1 = result.data.filter(x => x.cstatus == 1)
                }

                if (result1 != undefined) {
                    for (var x = 0; x < result1.length; x++) {
                        finaluserlist.push(result1[x])
                    }

                    for (var x = 0; x < result1.length; x++) {
                        finalmentionuserlist.push({ display: result1[x].userid, id: result1[x].userid, _id: usertemplist[x]._id })
                    }
                }

                var Grouphelper = {};
                var Grouphelperresult = finaluserlist.reduce(function (r, o) {
                    var key = o._id + '-' + o.userid;

                    if (!Grouphelper[key]) {
                        Grouphelper[key] = Object.assign({}, o); // create a copy of o
                        r.push(Grouphelper[key]);
                    } else {
                        Grouphelper[key].userid = o.userid;
                        //Grouphelper[key].sourceCount += o.sourceCount;
                        // Ghelper[key].instances += o.instances;
                    }
                    return r;
                }, []);

                var Grouphelper1 = {};
                var Grouphelperresult1 = finalmentionuserlist.reduce(function (r, o) {
                    var key = o.id;

                    if (!Grouphelper1[key]) {
                        Grouphelper1[key] = Object.assign({}, o); // create a copy of o
                        r.push(Grouphelper1[key]);
                    } else {
                        Grouphelper1[key].id = o.id;
                        //Grouphelper[key].sourceCount += o.sourceCount;
                        // Ghelper[key].instances += o.instances;
                    }
                    return r;
                }, []);

                console.log("finalmentionuserlist >>>", finalmentionuserlist)
                console.log("finaluserlist >>>", finaluserlist)
                console.log("Grouphelperresult1 >>>", Grouphelperresult1)
                // setMentionValue(Grouphelperresult1)
                // setUserLists(Grouphelperresult);

                setDataSourceCONTACT(finaluserlist)
                setDataSourceCONTACTDisplay(finaluserlist)
            })
            .catch(err => {
                console.log("555")
                message.error(GetTranslation(userlang, "Cannot get data"));
                setIsMaintenance(true);
            });


    }

    //====== ON GET USER LISTS ======= 
    const onRefreshContactlist = async () => {
        var result = await onGetUserContact({ userid: userid })

        var finaluserlist = []
        var finalmentionuserlist = []

        return getAllUserLists({})
            .then(user => {

                // setFULLUserLists(user.data)
                let usertemplist1 = user.data


                var tempuserid = usertemplist1.filter(x => x._id != userid);

                let tempmentionuserlist = []

                var usertemplist = []


                for (var x = 0; x < tempuserid.length; x++) {
                    usertemplist.push(tempuserid[x])
                }



                // console.log("result.data , ",result.data)

                // if (result.data != undefined) {
                //     for (var x = 0; x < result.data.length; x++) {
                //         usertemplist.push(result.data[x])
                //     }

                // }


                if (globalgrouping == "public") {

                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist

                }
                else if (globalgrouping == "private") {
                    let temptable = usertemplist
                    let temptable1 = usertemplist

                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1._id == userid;
                    });
                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });

                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    // if (result.data != undefined) {
                    //     for (var x = 0; x < result.data.length; x++) {
                    //         buildnew1.push(result.data[x])
                    //     }

                    // }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist
                }
                else if (globalgrouping == "department") {

                    let temptable = usertemplist
                    let temptable1 = usertemplist
                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1.department == globaldepartment;
                    });


                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });


                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist

                }
                else {
                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist
                }

                var newfinaluserlist = []
                var ownuserid = usertemplist1.filter(x => x._id == userid);

                newfinaluserlist.push(ownuserid[0])

                var tempcontactlisting = []

                if (result.data != undefined) {
                    for (var x = 0; x < result.data.length; x++) {
                        tempcontactlisting.push(result.data[x]);
                    }
                }

                // console.log("tempcontactlisting1,",tempcontactlisting)
                // Sort tempcontactlisting by 'cstatus' and then by 'cuserid'
                tempcontactlisting.sort((a, b) => {
                    if (a.cstatus === b.cstatus) {
                        return a.userid.localeCompare(b.userid);
                    }
                    return a.cstatus - b.cstatus; // Assuming cstatus is a number, we use subtraction for sorting
                });

                // console.log("tempcontactlisting2,",tempcontactlisting)
                // Filter finaluserlist to remove items where 'userid' exists in tempcontactlisting's 'userid'
                var filteredFinalUserList = finaluserlist.filter(finalUser =>
                    !tempcontactlisting.some(contact => contact._id === finalUser._id)
                );
                // console.log("filteredFinalUserList,",filteredFinalUserList)

                // Sort filteredFinalUserList by 'userid'
                filteredFinalUserList.sort((a, b) => a.userid.localeCompare(b.userid));

                // Push the sorted and filtered lists into newfinaluserlist
                newfinaluserlist.push(...tempcontactlisting, ...filteredFinalUserList);

                // console.log("finaluserlist >>>", finaluserlist)

                setDataSourceCONTACT(newfinaluserlist)
                setDataSourceCONTACTDisplay(newfinaluserlist)

                onGetUserContact({ userid: userid })
                    .then((val) => {
                        if (val.data.length > 0) {
                            // Count the number of objects where cstatus is 0
                            const countCStatusZero = val.data.reduce((count, obj) => {
                                if (obj.cstatus === 0 && obj.crequest === 0) {
                                    count += 1;
                                }
                                return count;
                            }, 0);
                            console.log("set pending contact number, ", countCStatusZero)

                            localStorage.setItem("pendingcontact", countCStatusZero)

                            // Manually trigger the badge update
                            if (typeof window.updatePendingContact === 'function') {
                                window.updatePendingContact();
                            }
                        }
                        else {
                            console.log("set pending contact number2, ", 0)
                            localStorage.setItem("pendingcontact", 0)
                            // Manually trigger the badge update
                            if (typeof window.updatePendingContact === 'function') {
                                window.updatePendingContact();
                            }
                        }

                        return val;
                    })
                    .catch(err => {
                        message.error(GetTranslation(userlang, "Cannot get data"));
                    });
            })
            .catch(err => {

                message.error(GetTranslation(userlang, "Cannot get data"));
                setIsMaintenance(true);
            });



    }

    useEffect(() => {
        onRefreshContactlist();
    }, []);

    useEffect(() => {

        if (approveAction != "") {
            ClicktoApprove(approveAction)
        }
        setApproveAction("")
    }, [approveAction]);

    useEffect(() => {

        if (searchAction != "") {
            ClicktoRequest(searchAction)
        }
        setSearchAction("")
    }, [searchAction]);

    useEffect(() => {

        if (removeAction != "") {
            ClicktoRemove(removeAction)
        }
        setRemoveAction("")
    }, [removeAction]);


    const onPressNewTask = async (val) => {

        //   localStorage.setItem("taskfilter","instructed")  
        // localStorage.setItem("tasktype",0)   
        // localStorage.removeItem("taskname")     
        // localStorage.setItem("taskpage",2)
        console.log("val data>>>", val)
        localStorage.setItem("action", "opennewtask")
        if (val != undefined && val != "") {
            localStorage.setItem("taskuserid", val)
        }

        // var data1 = {}
        // data1 = {taskfilter:"subordinary",tasktype:0}          
        // dispatch({ type: "dashboard1", payload: data1 });


    };
    const SearchUser = async (val) => {

        if (val != undefined) {
            if (val.length != 0) {
                setlistloading1(true)
                let data = {
                    searchparam: val
                }

                var result = await onSearchUser(data)

                let combined
                let combined1
                let contactlistid
                let contactlistid1
                if (datasourceCONTACT.length > 0) {
                    contactlistid = new Set(datasourceCONTACT.map(({ _id }) => _id));
                    combined = [
                        ...result.data.filter(({ _id }) => !contactlistid.has(_id))
                    ];
                }
                else {
                    combined = result.data
                }
                if (tempdatasourceCONTACT.length > 0) {
                    contactlistid1 = new Set(tempdatasourceCONTACT.map(({ _id }) => _id));
                    combined1 = [
                        ...combined.filter(({ _id }) => !contactlistid1.has(_id))
                    ];
                }
                else {
                    combined1 = combined
                }

                console.log("contactlistid >>>", contactlistid)
                console.log("contactlistid1 >>>", contactlistid1)



                let combined2 = combined1.filter(x => x.userid != userid);

                setsearchresult(combined2)
                if (result.data.length == 0) {
                    alert("0 Record found! ")
                }

                setlistloading1(false)
            }
            else {
                alert("Please Key in atleast 1 character ")
            }

        }
        else {
            setsearchresult("")
        }
    }
    const EnterSearchUser = async (val, event) => {
        if (event.key == "Enter") {
            if (val != undefined) {
                setlistloading1(true)
                let data = {
                    searchparam: val
                }

                var result = await onSearchUser(data)

                setsearchresult(result.data)
                if (result.data.length == 0) {
                    alert("0 Record found! ")
                }
                setlistloading1(false)
                console.log("result >>>", result)
            }
            else {
                setsearchresult("")
            }
        }

    }
    const InputSearchKeyword = async (val) => {

    }
    const showModal = (val, result) => {
        setModaladdContact(true)
        setsearchkeyword("")
        setsearchresult("")

    }
    const cancelModal = (val, result) => {

        setModaladdContact(false)
        onRefreshContactlist()
        setTempDataSourceCONTACT("")
    }

    const ClicktoRequest = async (val) => {
        let data = {
            cuserid: val,
            cstatus: 0,
            caddtime: moment().unix(),
            cselfid: userid,
            crequest: 1
        }


        let newds = searchresult;
        let newindex = newds.findIndex(x => x._id == val);

        newds[newindex].sstatus = 1;

        let tempresult = tempdatasourceCONTACT
        if (tempresult == "") {
            tempresult = []
        }
        tempresult.push(newds[newindex])
        setTempDataSourceCONTACT(tempresult)

        setsearchresult(newds)
        await onRequestAddUser(data)
    }

    const ClicktoApprove = async (val) => {


        let newds = datasourceCONTACT;
        let newindex = datasourceCONTACT.findIndex(x => x._id == val);

        let newds1 = datasourceCONTACTDisplay;
        let newindex1 = datasourceCONTACTDisplay.findIndex(x => x._id == val);

        newds[newindex].cstatus = 1;
        newds1[newindex1].cstatus = 1;

        setDataSourceCONTACT(newds);
        setDataSourceCONTACTDisplay(newds1);

        let data = {
            cuserid: val,
            cselfid: userid,
        }


        await onRequestAproveUser(data)
        onRefreshContactlist();
        message.success("Contact Approved !")

    }
    const ClicktoRemove = async (val) => {


        let newds = datasourceCONTACT.filter(x => x._id != val);

        let newds1 = datasourceCONTACTDisplay.filter(x => x._id != val);

        setDataSourceCONTACT(newds);
        setDataSourceCONTACTDisplay(newds1);

        let data = {
            cuserid: val,
            cselfid: userid,
        }



        await onRequestRemoveUser(data)
        onRefreshContactlist();
        message.success("Contact Removed !")

    }

    const KeyToSearch = async (val) => {
        // console.log("search val >>>", val)

        const lowerCaseVal = val.toLowerCase();

        const temp = datasourceCONTACT.filter(item =>
            item.userid.toLowerCase().includes(lowerCaseVal) ||
            item.contactno.toLowerCase().includes(lowerCaseVal) ||
            item.markingcode.toLowerCase().includes(lowerCaseVal)
        );

        // console.log("temp >>>", temp)
        setDataSourceCONTACTDisplay(temp)
    }


    var height = window.innerHeight;

    return (
        <>
            <Row justify="start">
                <Divider>Contact List</Divider>
            </Row>
            <div style={{ textAlign: 'center' }}>



                <Input

                    style={{ width: "70%" }}
                    placeholder={"Search With userid or mobile"}

                    onChange={(e) => KeyToSearch(e.target.value)}
                >

                </Input>
                <UserAddOutlined style={{ width: "10%", fontSize: "23px" }} onClick={(e) => showModal(e)}></UserAddOutlined>
            </div>
            <br />
            <div style={{ height: `${height * 0.9}px`, overflowY: "auto", overflowX: "hidden", }}>
                <List
                    dataSource={datasourceCONTACTDisplay}
                    renderItem={(item) => (
                        <div className="custom-list-item" >

                            <List.Item
                                actions=
                                {
                                    item.cstatus == 0
                                        ?
                                        item.crequest == 0
                                            ?
                                            [
                                                <Button onClick={() => ClicktoApprove(item._id)} type='primary'>Approve</Button>,
                                                <DeleteOutlined style={{ color: "red" }} onClick={() => setRemoveAction(item._id)} />

                                                // <Button onClick={() => setApproveAction(item._id)} type='primary'>Approve</Button>

                                            ]
                                            :
                                            [
                                                <a style={{ color: "red" }}>Pending</a>,

                                                <Popconfirm
                                                    title="Are you sure you want to delete this contact?"
                                                    onConfirm={() => setRemoveAction(item._id)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <DeleteOutlined style={{ color: "red" }} />
                                                </Popconfirm>
                                                // <DeleteOutlined style={{ color: "red" }} onClick={() => setRemoveAction(item._id)} />
                                            ]
                                        :
                                        [
                                            <a href="/TaskManagement"><Button onClick={() => onPressNewTask(item._id)} type='primary'>Chat</Button></a>,
                                            item.cstatus == 1 ?
                                                <>
                                                    <Popconfirm
                                                        title="Are you sure you want to delete this contact?"
                                                        onConfirm={() => setRemoveAction(item._id)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <DeleteOutlined style={{ color: "red" }} />
                                                    </Popconfirm>
                                                </>
                                                :
                                                <></>

                                            // <DeleteOutlined style={{ color: "red" }} onClick={() => setRemoveAction(item._id)} />
                                        ]}>
                                <List.Item.Meta
                                    title={<span className="userid">{item._id == userid ? `${item.userid} (SELF)` : item.userid}</span>}
                                    description={
                                        <>
                                            <div className="markingcode">{item.markingcode}</div>
                                            <div className="contactno">{item.contactno}</div>
                                        </>
                                    }
                                />
                            </List.Item>
                        </div>
                    )}>


                </List>
            </div>

            <Modal
                title="Add New Contact"
                destroyOnClose={true}
                visible={ModaladdContact}
                onCancel={cancelModal}
                footer={
                    <Button type='danger' onClick={cancelModal}>Cancel</Button>
                }
            >
                <div>
                    <Input style={{ width: "70%" }} value={searchkeyword}
                        onKeyPress={(e) => EnterSearchUser(searchkeyword, e)}
                        onChange={(e) => setsearchkeyword(e.target.value)}>
                    </Input>
                    <Button type="primary" disabled={listloading1} style={{ width: "30%" }} onClick={(e) => SearchUser(searchkeyword)}>
                        Search
                    </Button>
                </div>
                <div>
                    <Spin spinning={listloading1} size='large'>
                        <List
                            dataSource={searchresult}
                            renderItem={(item) => (
                                <List.Item
                                    actions={
                                        item.sstatus == 1
                                            ?
                                            [
                                                <Button type="danger">Pending</Button>
                                            ]
                                            :
                                            [
                                                //<Button onClick={() => ClicktoRequest(item._id)}>Request</Button>
                                                <Button onClick={() => setSearchAction(item._id)}>Request</Button>
                                            ]}
                                >
                                    <List.Item.Meta
                                        description={
                                            <a style={{ color: "black" }}>{item.userid}</a>
                                        }>
                                    </List.Item.Meta>
                                </List.Item>
                            )}>

                        </List>
                    </Spin>

                </div>
            </Modal>
        </>
    )
}